import { legacy_connect as connect } from 'react-redux';
import { Action, ActionCreator } from 'redux';
import { RootState } from '../../types';

import SearchBox from '../components/SearchBox';
import { searchAI, searchQueryUpdate } from '../../actions/search';
import { isAiSearchQuery } from '../../actions/aiSearch';
import { LITERATURE_NS } from '../../search/constants';
import { appendQueryToLocationSearch } from '../../actions/router';
import { clearLiteratureSelection } from '../../actions/literature';
import { UI_CITATION_SUMMARY_PARAM } from '../../literature/containers/CitationSummarySwitchContainer';
import { UI_EXCLUDE_SELF_CITATIONS_PARAM } from '../../literature/containers/ExcludeSelfCitationsContainer';
import { getConfigFor } from '../config';

const stateToProps = (state: RootState) => ({
  value: state.search.getIn([
    'namespaces',
    state.search.get('searchBoxNamespace'),
    'query',
    'q',
  ]),
  namespace: state.search.get('searchBoxNamespace'),
});

export const dispatchToProps = (dispatch: ActionCreator<Action>) => ({
  onSearch(namespace: string, value: string) {
    if (namespace !== LITERATURE_NS) {
      dispatch(
        appendQueryToLocationSearch({
          [UI_CITATION_SUMMARY_PARAM]: undefined,
          [UI_EXCLUDE_SELF_CITATIONS_PARAM]: undefined,
        })
      );
    } else {
      dispatch(clearLiteratureSelection());
      if (
        getConfigFor('QUERY_AI_ON_SEARCH_FEATURE_FLAG') &&
        !isAiSearchQuery(value)
      ) {
        dispatch(searchAI(value));
      }
    }

    dispatch(searchQueryUpdate(namespace, { q: value }));
  },
});

export default connect(stateToProps, dispatchToProps)(SearchBox);
